import { render } from "./Memberships.vue?vue&type=template&id=07a7d09e"
import script from "./Memberships.vue?vue&type=script&lang=js"
export * from "./Memberships.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__